import { ApplicationFormPageQuery } from "../../../generated/graphql-types";
import { ApplicationEvents } from "../../shared/analytics/analytics.consts";
import { quoteAmplitudeHelper } from "../../shared/analytics/analytics.utils";
import { Purpose } from "../../types/loan-parameters";

export const sendAppFormViewedEvent = (pageName: string) => {
  quoteAmplitudeHelper.sendEvent(
    `${ApplicationEvents.VIEWED_APP_FORM} - ${pageName}`
  );
};

export const sendLegacyRedirectEvent = (token: string | null) => {
  quoteAmplitudeHelper.sendEvent(ApplicationEvents.REDIRECT_TO_LEGACY, {
    token: token ? "valid" : "invalid",
  });
};

export const getDescriptionFromCommonPurposeByKey = (
  purposeKey: string,
  commonValues: NonNullable<ApplicationFormPageQuery["commonValues"]>
) => {
  return (
    commonValues.purposes.find((purpose) => purpose.code === purposeKey)
      ?.description ?? purposeKey
  );
};

export const getIsPurposeSecurableByKey = (
  purposeKey: string,
  loanPurposes: Purpose[]
) => {
  return (
    loanPurposes.find((purpose) => purpose.key === purposeKey)?.isSecurable ??
    false
  );
};

export const getPurposeDescriptionByKey = (
  purposeKey: string,
  loanPurposes: Purpose[]
) => {
  return (
    loanPurposes.find((purpose) => purpose.key === purposeKey)?.description ??
    purposeKey
  );
};
